jQuery(document).ready(function() {
	
	// Cycle Homepage Slides 
	$('#slideshow_wrap') 
		.before('<div id="slide_numbers_wrap">') 
		.cycle({ 
		    fx:     'fade', 
		    speed:  1000, 
		    timeout: 5000, 
		    pager:  '#slide_numbers_wrap',
			pause:   1 
	});
	
	
	
	
});